// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__y_DnH","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1g3sh","obliqueLine":"membershipbadge_obliqueLine__-HYft"};